import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchScreenReportThunk } from "../store/screen/thunk";
import { APP_CONSTANTS } from "../utilities/app_constants";
import RealTimeWarehouseActivity from "../screens/reports/RealTimeWarehouseActivity";
import StockPositionReport from "../screens/reports/StockPositionReport";
import VehicleInformationReport from "../screens/reports/VehicleInformationReport";
import WarehouseStatus from "../screens/reports/WarehouseStatus";
import DrierStatusReport from "../screens/reports/DrierStatusReport";
import RealTimeLineActivity from "../screens/reports/RealTimeLineActivity";
import { useLocation } from "react-router-dom";
import StockPositionNonSeed from "../screens/reports/StockPositionNonSeed";
import ExternalImagesReport from "../screens/reports/ExternalImagesReport";

const ScreenReports = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { screenReport, loading, error } = useSelector((state) => state.screens);

  const screenId = location.state?.screenId;
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  const handleNext = () => {
    setCurrentIndex((prev) => (prev + 1) % screenReport.data.length);
  };

  const handlePrevious = () => {
    setCurrentIndex((prev) => (prev - 1 + screenReport.data.length) % screenReport.data.length);
  };

  const handlePause = (pause) => {
    setIsPaused(pause);
  };

  useEffect(() => {
    if (screenId) {
      dispatch(fetchScreenReportThunk(screenId));
    }
  }, [dispatch, screenId]);

  // useEffect(() => {
  //   if (screenReport?.data?.length > 0) {
  //     const interval = setInterval(() => {
  //       setCurrentIndex(
  //         (prevIndex) => (prevIndex + 1) % screenReport.data.length
  //       );
  //     }, APP_CONSTANTS.REPORT_DISPLAY_TIME); // Switch report every 1 min

  //     return () => clearInterval(interval);
  //   }
  // }, [screenReport?.data?.length]);

  const currentReport = screenReport?.data?.[currentIndex];

  return (
    <div>
      {loading && <p>Loading...</p>}
      {error && <p>Error loading reports</p>}

      {currentReport ? (
        <div>
          {currentReport.reportName === "Real Time line Activity" && (
            <RealTimeLineActivity
            reportData={currentReport}
            key={currentReport.reportId}
            onNext={handleNext}
            onPrevious={handlePrevious}
            onPause={handlePause}
            isPaused={isPaused}
          />
          )}
          {currentReport.reportName === "Real Time Warehouse Activity" && (
            <RealTimeWarehouseActivity
            reportData={currentReport}
            key={currentReport.reportId}
            onNext={handleNext}
            onPrevious={handlePrevious}
            onPause={handlePause}
            isPaused={isPaused}
            />
          )}
          {currentReport.reportName === "Stock Position Report" && (
            <StockPositionReport
            reportData={currentReport}
            key={currentReport.reportId}
            onNext={handleNext}
            onPrevious={handlePrevious}
            onPause={handlePause}
            isPaused={isPaused}
            />
          )}
          {currentReport.reportName === "Stock Position Non Seed Report" && (
            <StockPositionNonSeed
            reportData={currentReport}
            key={currentReport.reportId}
            onNext={handleNext}
            onPrevious={handlePrevious}
            onPause={handlePause}
            isPaused={isPaused}
            />
          )}
          {currentReport.reportName === "Vehicle Information Report" && (
            <VehicleInformationReport
            reportData={currentReport}
            key={currentReport.reportId}
            onNext={handleNext}
            onPrevious={handlePrevious}
            onPause={handlePause}
            isPaused={isPaused}
            />
          )}
          {currentReport.reportName === "Warehouse Status Report" && (
            <WarehouseStatus
            reportData={currentReport}
            key={currentReport.reportId}
            onNext={handleNext}
            onPrevious={handlePrevious}
            onPause={handlePause}
            isPaused={isPaused}
            />
          )}
          {currentReport.reportName === "Driar Status Report" && (
            <DrierStatusReport
            reportData={currentReport}
            key={currentReport.reportId}
            onNext={handleNext}
            onPrevious={handlePrevious}
            onPause={handlePause}
            isPaused={isPaused}
            />
          )}
          {currentReport.reportName === "External Images Report" && (
            <ExternalImagesReport
            reportData={currentReport}
            key={currentReport.reportId}
            onNext={handleNext}
            onPrevious={handlePrevious}
            onPause={handlePause}
            isPaused={isPaused}
            />
          )}
        </div>
      ) : (
        <p>No reports available</p>
      )}
    </div>
  );
};

export default ScreenReports;
